import * as R from 'ramda'
import React from 'react'
import Qs from 'qs'
import { Route } from 'react-router-dom'
import { notNil } from './lib/helpers'
import Home from './containers/home'
// import Page from './containers/page'
// import Reviews from './containers/page-reviews'
// import Shop from './containers/shop'
// import Product from './containers/product'
// import Categories from './containers/categories'
// import SubscriptionsPage from './containers/subscriptions'
// import SubscriptionEditPage from './containers/subscriptions/edit'

const FROM_INDEX = 1

const parseQuery = props =>
  R.compose(
    R.when(
      notNil,
      R.compose(
        R.merge(props),
        R.objOf('query'),
        Qs.parse,
        R.slice(FROM_INDEX, Infinity)
      )
    ),
    R.path(['location', 'search'])
  )(props)

// MAINTENANCE: every path renders the home page while the backend is down.
// Restore the original route table below when the site is back.
const RouteFunctor = [{ path: '/', component: Home }]
/*
const RouteFunctor = [
  { path: '/', component: Home, exact: true },
  { path: '/subscriptions', component: SubscriptionsPage, exact: true },
  {
    path: '/subscriptions/:subscription_id',
    component: SubscriptionEditPage,
    exact: true,
  },
  { path: '/shop', component: Shop, exact: true },
  { path: '/reviews', component: Reviews, exact: true },
  { path: '/shop/category/:category', component: Categories, exact: true },
  { path: '/shop/:slug', component: Product },
  { path: '/:slug', component: Page },
]
*/

const RouteActor = route => (
  <Route
    path={route.path}
    exact={route.exact}
    render={props => {
      const _props = parseQuery(props)

      props.history.listen(() => window.scroll(0, 0))

      return <route.component {..._props} routes={route.sub_routes} />
    }}
  />
)

export { RouteActor, RouteFunctor }
